var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "" } },
    [
      _c(
        "v-layout",
        { staticClass: "event", attrs: { column: "" } },
        [
          _c(
            "chat-user-header",
            {
              attrs: {
                "main-icon": _vm.mainIcon,
                event: _vm.event,
                participants: _vm.participants
              }
            },
            [_vm._v("\n      uploaded a file\n    ")]
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            {
              staticClass: "text-xs-left event-line ml-1",
              attrs: { xs12: "", sm12: "", "align-center": "" }
            },
            [
              _c(
                "v-layout",
                { attrs: { "align-center": "", "fill-height": "", wrap: "" } },
                [
                  _c("span", { staticClass: "pl-4 font-weight-light" }, [
                    _vm._v(
                      "\n          " + _vm._s(_vm.event.message) + "\n        "
                    )
                  ])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.showTime
            ? _c(
                "v-flex",
                {
                  staticClass:
                    "text-sm-right text-sm-left event-line font-weight-light caption pr-2",
                  attrs: { xs12: "", sm2: "" }
                },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm._f("formatDate")(_vm.event.timestamp)))
                  ])
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "event-media" }, [
        _c(
          "a",
          {
            on: {
              click: function($event) {
                return _vm.openAttachment(_vm.media.link)
              }
            }
          },
          [
            _vm.isImage
              ? _c("img", {
                  attrs: {
                    src: _vm.getAttachmentUrl(_vm.media.link),
                    height: "40",
                    width: "40",
                    id: "event-img-" + _vm.media.link
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isPdfAttachment
              ? _c(
                  "icon-base",
                  {
                    attrs: {
                      width: "40",
                      height: "40",
                      "icon-name": "pdf",
                      viewBox: "0 0 32 32",
                      "icon-color": "black"
                    }
                  },
                  [_c("icon-pdf")],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d84eace", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d84eace","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/timeline/UserMediaUploadEvent.vue
// module id = null
// module chunks = 